import { render, staticRenderFns } from "./BriefDescription.vue?vue&type=template&id=f176483a&"
import script from "./BriefDescription.vue?vue&type=script&lang=js&"
export * from "./BriefDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports